import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { toastr } from 'react-redux-toastr'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import Autocomplete from 'react-autocomplete'
import { connect } from 'react-redux'
import momentDurationFormatSetup from 'moment-duration-format'
import Toggle from 'react-toggle'
import { useTranslation } from 'react-i18next'
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/flatpickr.min.css"
import { format } from "date-fns";
import momenttz from '../../../helpers/momenttz'
import CustomButton from '../../../CustomButton'
import ModalDelete from '../ModalDelete'
import DetailsScenario from './DetailsScenario'
import { requestEventVideo } from '../../../../../../shared/api/action/AlertActions'
import './CustomVideoRequest.sass'
import CalendarDropdown from "../../CalendarDropdown";
import { getAvailableVideoDates, getDeviceAvailableVideo } from "../../../../../../shared/api/action/DeviceActions";

momentDurationFormatSetup(moment)

const CustomVideoRequest = (props) => {
	const { devices, propsSelectedDevice, propsSelectedDate, propsStartTime, propsEndTime, user, company, onHide, onSave, toggleLoader } = props;
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'modals.customVideoRequest' });
	const userRole = user.roles[0]
	const partnerName = company.partner || user.partner_company_name
	const companyType = company.type || user.company_type

	const inputVehicleRef = useRef(null)

	const [scenario, setScenario] = useState('simple')
	const [selectedDevice, setSelectedDevice] = useState()
	const [videoDate, setVideoDate] = useState(momenttz())
	const [availableVideoDates, setAvailableVideoDates] = useState([])
	const [availableVideos, setAvailableVideos] = useState([])
	const [startTime, setStartTime] = useState(null)
	const [endTime, setEndTime] = useState(null)
	const [durationMinutes, setDurationMinutes] = useState(0)
	const [durationSeconds, setDurationSeconds] = useState(0)
	const [autoValueDevice, setAutoValueDevice] = useState('')
	const [showMultipleRequestsModal, setShowMultipleRequestsModal] = useState(false)
	const [showMakeAnotherRequestModal, setShowMakeAnotherRequestModal] = useState(false)
	const [showRequestSnapshotsOnlyModal, setShowRequestSnapshotsOnlyModal] = useState(false)
	const [errorDurationSnapshotOnly, setErrorDurationSnapshotOnly] = useState(false)
	const [errMessage, setErrMessage] = useState({
		err_vehicle: '',
		err_start_time: '',
		err_end_time: '',
	})
	const [snapshot_only, setSnapshot_only] = useState(false)

	const isDifferentDays = () => (moment(startTime, 'HH:mm:ss').isSameOrAfter(moment('23:00:00', 'HH:mm:ss')) && moment(endTime, 'HH:mm:ss').isSameOrBefore(moment('01:00:00', 'HH:mm:ss')));

	const getFullDurationSeconds = () => {
		let res = 0

		if (startTime && endTime) {
			let time1 = new Date(`1970-01-01T${startTime}Z`)
			let time2 = new Date(`1970-01-01T${endTime}Z`)

			isDifferentDays() && (time2 = time2.setDate(time2.getDate() + 1));
			res = moment(time2).diff(moment(time1), 'seconds');
		}

		return res
	}

	const calculateEndTime = (start, minutes, seconds) => {
		if (start) {
			const timestamp = moment(start, "HH:mm:ss").valueOf();
			const duration = minutes * 60 + seconds;
			return timestamp + duration * 1000;
		}
		return null;
	}

	const calculateDuration = (start, end) => {
		let error = false;
		let diffSeconds = 0;
		let diffMinutes = 0;

		if (start && end) {
			const diffMilliseconds = getFullDurationSeconds(start, end)
			diffSeconds = Math.floor((diffMilliseconds) % 60)
			diffMinutes = Math.floor((diffMilliseconds / 60))

			if (snapshot_only) {
				if (!validDurationSnapshotOnly() && errorDurationSnapshotOnly) {
					error = true
				} else {
					errorDurationSnapshotOnly && setErrorDurationSnapshotOnly(false)
				}
			}

			if (diffMinutes < 0 || diffSeconds < 0 || diffMilliseconds < 5 || diffMilliseconds > 3600) {
				error = true
				diffMinutes = 0
				diffSeconds = 0
			}
		}

		return {
			diffMinutes,
			diffSeconds,
			error,
		}
	};

	useEffect(() => {
		inputVehicleRef.current?.focus()

		if (propsSelectedDevice) {
			setSelectedDevice(propsSelectedDevice)
		}
		if (propsSelectedDate) {
			setVideoDate(propsSelectedDate)
		}

		if (propsStartTime && propsEndTime) {
			setStartTime(propsStartTime)
			setEndTime(propsEndTime)
		}
	}, [])

	useEffect(() => {
		setAvailableVideoDates([])

		if (selectedDevice) {
			getAvailableVideDates()
		}

		if (snapshot_only) {
			setSnapshot_only(false)
		}
	}, [selectedDevice])

	useEffect(() => {
		if (selectedDevice && videoDate) {
			getAvailableVideos()
		}
	}, [videoDate, scenario])

	useEffect(() => {
		if (startTime && errMessage.err_start_time) {
			setErrMessage({ ...errMessage, err_start_time: '' })
		}
		if (endTime && errMessage.err_end_time) {
			setErrMessage({ ...errMessage, err_end_time: '' })
		}
		if (startTime && endTime) {
			const { diffMinutes, diffSeconds } = calculateDuration(startTime, endTime);
			setDurationMinutes(diffMinutes);
			setDurationSeconds(diffSeconds);
		}
	}, [startTime, endTime]);

	useEffect(() => {
		if (startTime && (durationMinutes || durationSeconds)) {
			const endTimeTimestamp = endTime ? moment(endTime, "HH:mm:ss").valueOf() : null;
			const newEndTime = calculateEndTime(startTime, durationMinutes, durationSeconds);
			if (newEndTime !== endTimeTimestamp) {
				setEndTime(newEndTime ? moment(newEndTime).format('HH:mm:ss') : null);
			}
		}
	}, [durationMinutes, durationSeconds]);

	const getAvailableVideDates = () => {
		toggleLoader(true)
		getAvailableVideoDates({ deviceId: selectedDevice.device_id, timezone: timezone() })
			.then(res => {
				setAvailableVideoDates(res.data.response.available_video_dates)
				toggleLoader(false)
			})
			.catch(error => {
				console.log('!getAvailableVideDates error: ', error.response, error)
				toggleLoader(false);
				let errDescription = t('errAvailableVideo');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}

	const getAvailableVideos = () => {
		toggleLoader(true)
		const params = {
			device_id: selectedDevice.device_id,
			start_time: momenttz(moment(videoDate).format('YYYY-MM-DD 00:00:00')).utc().format('YYYYMMDDHHmmss'),
			end_time: momenttz(moment(videoDate).format('YYYY-MM-DD 23:59:59')).utc().format('YYYYMMDDHHmmss')
		}
		getDeviceAvailableVideo(params)
			.then(res => {
				toggleLoader(false)

				let { available_video } = res.data.response[0]

				// replaces the all values '3' with the previous value in available_video string
				let pos = available_video.indexOf('3')
				while (pos > -1) {
					if (pos === 0) {
						available_video = available_video.substring(0, pos) + '0' + available_video.substring(pos)
						// available_video[pos] = '0'
					}
					else {
						available_video = available_video.substring(0, pos) + available_video[pos - 1] + available_video.substring(pos + 1)
					}
					pos = available_video.indexOf('3')
				}

				setAvailableVideos(available_video || [])
			})
			.catch(error => {
				toggleLoader(false)
				console.log('getAvailableVideos error: ', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}

	const onDateChanged = (current) => {
		if (!moment(current, 'MM-DD-YYYY', true).isValid()) {
			toastr.error('', i18n.t('toastMessage.toastrInfoValidDate'))
			return
		}
		setVideoDate(current)
		if (availableVideoDates.length && availableVideoDates.includes(moment(current).format('YYYY-MM-DD'))) {
			setScenario('details')
		}
	}

	const validDurationSnapshotOnly = () => {
		return fullDurationSeconds >= 300 && fullDurationSeconds <= 3600
	}

	const durationRender = () => {
		const { error } = calculateDuration(startTime, endTime);

		return (
			<div className={`duration-wrapper${error ? ' has-error' : ''}`}>
				<div>{t('durationTitle')}</div>
				<div className="duration">
					<div className="mr-5">
						<label>{t('durationMinutes')}</label>
						<input
							type="number"
							disabled={!startTime}
							step="1"
							min="0"
							name="durationMinutes"
							style={{
								width: '100%',
								...(error && { border: '1px solid red' }),
							}}
							value={durationMinutes}
							onChange={(e) => setDurationMinutes(+e.target.value)}
						/>
					</div>
					<div>
						<label>{t('durationSeconds')}</label>
						<input
							type="number"
							disabled={!startTime}
							step="1"
							min="0"
							max="59"
							name="durationSeconds"
							style={{
								width: '100%',
								...(error && { border: '1px solid red' }),
							}}
							value={durationSeconds}
							onChange={(e) => setDurationSeconds(+e.target.value)}
						/>
					</div>
				</div>
				{error && <div className="help-block">{t('errDuration')}</div>}
			</div>
		)
	}

	const checkForm = (videosArg) => {
		let errMessage = ''
		videosArg.forEach((videoitem) => {
			if (!videoitem.device_id) {
				errMessage = t('errMessageSelectVehicle')
			}
			const diff = videoitem.end_ts - videoitem.start_ts
			if (diff < 5) {
				if (videosArg.length > 1) {
					errMessage = t('errMessageLastRequest')
				} else {
					errMessage = t('errMessageRequest')
				}
			}
		})
		if (errMessage) {
			toastr.error(errMessage)
		}
		return !!errMessage
	}

	const onClickRequestVideo = () => {
		const requestDuration = fullDurationSeconds;

		if (snapshot_only) {
			if (validDurationSnapshotOnly()) {
				setShowRequestSnapshotsOnlyModal(true)
			} else {
				setErrorDurationSnapshotOnly(true)
			}
		} else {
			// If the request duration is longer than 5 minutes, the request will be “split” into separate custom video requests.
			if (requestDuration > 300) {
				setShowMultipleRequestsModal(true)
			}
			else {
				sendRequest()
			}
		}
	}

	// Prepares array of video clips with params
	const getVideosList = () => {
		const res = [];
		if (!snapshot_only) {
			const countRequests = Math.ceil(fullDurationSeconds / 300)
			for (let i = 0; i < countRequests; i++) {
				const start_ts = momenttz(moment(moment(videoDate).format('YYYY-MM-DD ') + startTime).add(300 * i, 'seconds')).utc().format('YYYYMMDDHHmmss')
				let end_ts = moment(start_ts, 'YYYYMMDDHHmmss').add(299, 'seconds').format('YYYYMMDDHHmmss')
				if (i === countRequests - 1) {
					end_ts = momenttz(moment((!isDifferentDays() ? moment(videoDate, 'YYYYMMDDHHmmss') : moment(videoDate, 'YYYYMMDDHHmmss').add(1, 'days')).format('YYYY-MM-DD ') + endTime)).utc().format('YYYYMMDDHHmmss')
				}
				const timestamp = moment(start_ts, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')

				res.push({ device_id: selectedDevice.device_id, start_ts, end_ts, timestamp, snapshot_only })
			}
		} else {
			const start_ts = momenttz(moment(moment(videoDate).format('YYYY-MM-DD ') + startTime)).utc().format('YYYYMMDDHHmmss')
			const end_ts = !isDifferentDays() ? momenttz(moment(moment(videoDate).format('YYYY-MM-DD ') + endTime)).utc().format('YYYYMMDDHHmmss') : momenttz(moment(moment(videoDate, 'YYYYMMDDHHmmss').add(1, 'days').format('YYYY-MM-DD ') + endTime)).utc().format('YYYYMMDDHHmmss')
			const timestamp = moment(start_ts, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')

			res.push({ device_id: selectedDevice.device_id, start_ts, end_ts, timestamp, snapshot_only })
		}
		return res
	}

	const sendRequest = (e) => {
		const requestArray = []
		const videosList = getVideosList()
		const error = checkForm(videosList)
		if (!error) {
			toggleLoader(true)
			videosList.forEach((item) => {
				requestArray.push(requestEventVideo(item))
			})

			Promise.all(requestArray)
				.then(res => {
					toggleLoader(false)

					let eventId = [];
					if (res[0].data.response.request_id) {
						eventId = res[0].data.response.request_id
					} else if (res[0].data.response.saved_files_ids) {
						eventId = res[0].data.response.saved_files_ids
					}

					onSave(
						{
							event_ts: videosList[0].timestamp,
							event_device_id: videosList[0].device_id,
							event_id: eventId,
						}
					)
					setShowMakeAnotherRequestModal(true)
					toastr.success('', t('toatrMessRequest'))
				})
				.catch((error) => {
					toggleLoader(false)
					console.log('sendRequest PromiseAll catch ERROR: ', error);
					let errDescription = i18n.t('errorMessage.errDescription');
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				});
		}
	}

	const isDayDisabled = (current) => {
		return !moment(current).isSameOrBefore(moment())
	}

	const optsRequest = {}
	if (userRole === 'sales_demo') {
		optsRequest.disabled = 'disabled'
	}

	if (partnerName === 'Rosco Vision WCS' || companyType === 'WCS') {
		displayTimeFormat = 'MM-DD-YYYY hh:mm A'
	}

	const displayItemName = item => item.vehicle_name || item.device_id

	const getItemValue = item => item.vehicle_name || item.device_id

	const matchStateToTerm = (item, value) => {
		if (item.vehicle_name) {
			return item.vehicle_name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
		}

		return item.device_id.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
	}

	const resetDurationValues = () => {
		setDurationMinutes(0);
		setDurationSeconds(0);
	}

	const setPropTime = (startTimeArg, endTimeArg, isDisabledTime = null) => {
		if (startTimeArg) {
			setStartTime(startTimeArg)
		} else {
			setStartTime('')
			resetDurationValues()
		}
		if (endTimeArg) {
			setEndTime(endTimeArg)
		} else {
			setEndTime('')
			resetDurationValues()
		}
	}

	const customDayContent = (day) => {
		const highlightedDates = [...availableVideoDates]
		let classes = '';
		if (highlightedDates.length && highlightedDates.some(date => moment(date).isSame(day, "day"))) {
			classes += "highlighted-day";
		}
		return <span className={classes}>{format(day, "d")}</span>
	}

	const timezone = () => {
		const tz = momenttz().utcOffset();
		const timezone = 'UTC' + ((tz > 0) ? '+' : '') + tz / 60;

		return timezone;
	}

	const fullDurationSeconds = getFullDurationSeconds()
	const isRequestDisabled = !selectedDevice || fullDurationSeconds < 5 || fullDurationSeconds > 3600

	const renderCustomCalendar = (props, openCalendar, closeCalendar) => {
		return (
			<div>
				{/* Render the default calendar */}
				{props}

				{/* Custom footer text */}
				<div style={{ padding: "10px", textAlign: "center", borderTop: "1px solid #ccc" }}>
					<small>Custom footer text here</small>
				</div>
			</div>
		);
	};

	const getCalendarFooter = () => {
		return (
			<div className="calendar-date-legend">
				<div className="legend-option">
					<div className="legend-icon" id="req-details">1</div>
					<p className="legend-description">{t('reqDetails')}</p>
				</div>
				<div className="legend-option">
					<div className="legend-icon" id="req">1</div>
					<p className="legend-description">{t('req')}</p>
				</div>
				<div className="legend-option">
					<div className="legend-icon" id="no-req">1</div>
					<p className="legend-description">{t('noReq')}</p>
				</div>
			</div>
		)
	}

	return (
		<Modal
			show
			size="lg"
			onHide={onHide}
			dialogClassName="customRequestModal"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg" className='action-title'>
					{`${t('titleCVR')} ${propsSelectedDevice && ' - ' + propsSelectedDevice.vehicle_name}`}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row">
					<p style={{ mmarginBottom: propsSelectedDevice ? '0px' : '35px' }}>
						{propsSelectedDevice
							? t('selectDateTitle')
							: t('selectVehicleTitle')
						}
					</p>
					<div className="row-flex">
						{!propsSelectedDevice && (
							<div className={`col-xs-12 col-sm-12 col-md-12 form-group vehicle-group${errMessage.err_vehicle ? ' has-error' : ''}`}>
								<Autocomplete
									ref={inputVehicleRef}
									autoHighlight
									value={autoValueDevice}
									inputProps={{
										id: 'states-autocomplete',
										onBlur: () => setErrMessage({ ...errMessage, err_vehicle: !selectedDevice ? 'required' : '' })
									}}
									wrapperProps={{ className: 'search-autocomplete' }}
									wrapperStyle={{ position: 'relative' }}
									getItemValue={getItemValue}
									shouldItemRender={matchStateToTerm}
									menuStyle={{
										borderRadius: '3px',
										boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
										background: 'rgba(255, 255, 255, 0.9)',
										padding: '2px 0',
										fontSize: '90%',
										position: 'absolute',
										overflow: 'auto',
										maxHeight: '200px',
										left: '0',
										top: 'auto',
										zIndex: 1,
									}}
									onChange={(e, value) => {
										setAutoValueDevice(value)
										setSelectedDevice('')
									}}
									onSelect={(value, item) => {
										setAutoValueDevice(value)
										setSelectedDevice(item)
									}}
									renderMenu={function (items, value, style) {
										return <div className="items-list" style={{ ...style, ...this.menuStyle }} children={items} />
									}}
									renderItem={(item, isHighlighted) => (
										<option
											className={`item ${isHighlighted ? 'item-highlighted' : ''} `}
											key={item.device_id}
										>
											{displayItemName(item)}
										</option>
									)}
									renderInput={props => (
										<div className="select-box">
											<label className="control-label text-label">{t('titleCVR')}</label>
											<input {...props} list="list" type="text" value={autoValueDevice} className="vehicle-search" />
										</div>
									)}
									items={devices}
								/>
								{errMessage.err_vehicle && <div className="help-block">{t('errHelpBlock')}</div>}
							</div>
						)}

						<div className="available-dates-nav">
							<div className="input event-date">
								<CalendarDropdown
									date={moment(videoDate)}
									disabledDay={isDayDisabled}
									displayFormat='MM-DD-YYYY'
									onChange={onDateChanged}
									dayContentRenderer={customDayContent}
									footer={getCalendarFooter()}
								/>
							</div>
						</div>
					</div>

					<div className="tab-bar-container">
						<div className="tab-buttons">
							<CustomButton
								prefix={`toggle ${(scenario === "simple") && "active"} `}
								onClick={() => setScenario('simple')}
							>
								{t('buttonSimple')}
							</CustomButton>
							<CustomButton
								prefix={`toggle ${(scenario === "details") && "active"} `}
								onClick={() => setScenario('details')}
							>
								{t('buttonDetails')}
							</CustomButton>
						</div>
					</div>

					<div className="bottom-block">
						<div className="text-block" dangerouslySetInnerHTML={{ __html: t('textBlock') }} />

						<div className="toggle">
							<span className="toggle-title"><b>{t('titleRequestSnapshotsOnly')}</b></span>
							<span>
								<Toggle
									disabled={!selectedDevice || selectedDevice?.device_type !== 'dv6'}
									checked={snapshot_only}
									onChange={e => setSnapshot_only(e.target.checked)}
								/>
							</span>
						</div>

						<div className="request-time-range">
							<div className={`start-time${errMessage.err_start_time ? ' has-error' : ''}`}>
								<label>{t('titleStartTime')}</label>
								<div id="start-time">
									<Flatpickr
										data-enable-time
										value={startTime}
										onChange={([time]) => {
											setStartTime(time ? moment(time).format('HH:mm:ss') : null)
										}}
										onClose={([time]) => setErrMessage({ ...errMessage, err_start_time: !time ? 'required' : '' })}
										options={{
											static: true,
											enableTime: true,
											noCalendar: true,
											enableSeconds: true,
											dateFormat: "G:i:S K",
											minuteIncrement: 1,
										}}
									/>
								</div>
								{errMessage.err_start_time && <div className="help-block">{t('errHelpBlock')}</div>}
							</div>

							{durationRender()}

							<div className={`end-time${errMessage.err_end_time ? ' has-error' : ''}`}>
								<label>{t('titleEndTime')}</label>
								<div id="end-time">
									<Flatpickr
										data-enable-time
										value={endTime}
										onChange={([time]) => {
											setEndTime(time ? moment(time).format('HH:mm:ss') : null)
										}}
										onClose={([time]) => setErrMessage({ ...errMessage, err_end_time: !time ? 'required' : '' })}
										options={{
											static: true,
											enableTime: true,
											noCalendar: true,
											enableSeconds: true,
											dateFormat: "G:i:S K",
											minuteIncrement: 1,
										}}
									/>
								</div>
								{errMessage.err_end_time && <div className="help-block">{t('errHelpBlock')}</div>}
							</div>
						</div>

						{scenario === 'details' &&
							<DetailsScenario
								videoDate={videoDate}
								availableVideos={availableVideos}
								userRole={userRole}
								setPropTime={setPropTime}
								snapshotOnly={snapshot_only}
							/>
						}
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<CustomButton
					variant="primary-outline"
					prefix="rosco-primary-cancel btn btn-default"
					onClick={() => onHide()}
				>
					{t('btnCancel')}
				</CustomButton>
				<CustomButton
					variant="primary"
					prefix={`btn ${isRequestDisabled ? 'custom-disabled' : ''} `}
					onClick={() => onClickRequestVideo()}
					disabled={isRequestDisabled}
					{...optsRequest}
				>
					{t('btnRequest')}
				</CustomButton>
			</Modal.Footer>

			{showMultipleRequestsModal &&
				<ModalDelete
					title={t('modalDeleteMultipleRequests.title')}
					content={t('modalDeleteMultipleRequests.content', { durationSeconds: Math.ceil(fullDurationSeconds / 300) })}
					styleView="primary"
					backdropClassName="upper text-center"
					styleBtn={{ width: '157px' }}
					showClose
					closeBtnName={t('modalDeleteMultipleRequests.closeBtnName')}
					deleteBtnName={t('modalDeleteMultipleRequests.deleteBtnName')}
					closeModal={() => setShowMultipleRequestsModal(false)}
					deleteModal={sendRequest}
				/>
			}

			{showMakeAnotherRequestModal &&
				<ModalDelete
					title={t('modalDeleteAnotherRequest.title')}
					content={t('modalDeleteAnotherRequest.content')}
					styleView="primary"
					backdropClassName="upper text-center"
					styleBtn={{ width: '83px' }}
					showClose
					closeBtnName={t('modalDeleteAnotherRequest.closeBtnName')}
					deleteBtnName={t('modalDeleteAnotherRequest.deleteBtnName')}
					closeModal={() => { setShowMakeAnotherRequestModal(false); onHide(); }}
					deleteModal={() => setShowMakeAnotherRequestModal(false)}
				/>
			}

			{showRequestSnapshotsOnlyModal &&
				<ModalDelete
					title={t('modalDeleteRequestSnapshotsOnly.title')}
					content={t('modalDeleteRequestSnapshotsOnly.content')}
					styleView="primary"
					backdropClassName="upper text-center"
					styleBtn={{ width: '83px' }}
					showClose
					closeBtnName={t('modalDeleteRequestSnapshotsOnly.closeBtnName')}
					deleteBtnName={t('modalDeleteRequestSnapshotsOnly.deleteBtnName')}
					closeModal={() => setShowRequestSnapshotsOnlyModal(false)}
					deleteModal={() => { sendRequest(); setShowRequestSnapshotsOnlyModal(false) }}
				/>
			}
		</Modal>
	);
}

CustomVideoRequest.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	propsSelectedDevice: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.objectOf(PropTypes.any),
	]),
	devices: PropTypes.arrayOf(PropTypes.any),
	onHide: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired
}

CustomVideoRequest.defaultProps = {
	propsSelectedDevice: '',
	devices: []
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(CustomVideoRequest);
